// Toggle the menu open and close when on mobile
export default function navigation() {
    // Highlight current item for subpages
    const burgerButton = document.querySelector('#menu-button');
    const closeButton = document.querySelector('#menu-close-button');
    const navUnderlay = document.querySelector('#nav-underlay');
    navUnderlay.style.opacity = 0;
    burgerButton.addEventListener('click', function () {
        navUnderlay.style.display = 'block';
        navUnderlay.animate({opacity: [0, 1]}, {duration: 500, fill: 'forwards'});
        document.body.classList.add('is-menu-open');
    });
    closeButton.addEventListener('click', function () {
        if(document.body.classList.contains('is-menu-open')) {
            navUnderlay.animate({opacity: 0}, {duration: 500});
            setTimeout(function() {
                navUnderlay.style.display = 'none';
            }, 500);
            document.body.classList.remove('is-menu-open');
        }
    });
    navUnderlay.addEventListener('click', function () {
        if(document.body.classList.contains('is-menu-open')) {
            navUnderlay.animate({opacity: 0}, {duration: 500});
            setTimeout(function() {
                navUnderlay.style.display = 'none';
            }, 500);
            document.body.classList.remove('is-menu-open');
        }
    });

    // Current nav highlighting for sub pages
    const body = document.querySelector('body');
    if(body.classList.contains('tag-template')) {
        if(document.querySelector('nav li.nav-resources')) {
            document.querySelector('nav li.nav-resources').classList.add('nav-current');
        }
    }
    if(body.classList.contains('post-template')) {
        if(document.querySelector('nav li.nav-resources')) {
            document.querySelector('nav li.nav-resources').classList.add('nav-current');
        }
    }
    if(body.classList.contains('page-book-as-a-speaker')) {
        if(document.querySelector('nav li.nav-about-me')) {
            document.querySelector('nav li.nav-about-me').classList.add('nav-current');
        }
    }
}